export default __webpack_public_path__ + "static/media/about-3.4c6948da.jpg";